import { PARTNER_DEMO, readPartnerDemo } from "@/core/data/demoState";
import {
	type PartnerProfile,
	SAMPLE_PARTNER_BY_DEMO,
} from "./samplePartnerFixtures";

export type PartnerSessionDataSource = {
	loadPartnerProfile: () => PartnerProfile;
};

export const ACTIVATION_STEP = {
	Curation: 1,
	PartnerData: 2,
	Contract: 3,
	Activation: 4,
} as const;

export type ActivationStep =
	(typeof ACTIVATION_STEP)[keyof typeof ACTIVATION_STEP];

export const ACTIVATION_STEP_COUNT = 4;

export const isNewPartner = (partnerProfile: PartnerProfile) =>
	partnerProfile.isAccountActive && !partnerProfile.isPortalActivated;

export const resolveActivationStep = (
	partnerProfile: PartnerProfile,
): ActivationStep => {
	if (!partnerProfile.isPartnerDataSubmitted)
		return ACTIVATION_STEP.PartnerData;
	if (!partnerProfile.isContractApproved) return ACTIVATION_STEP.Contract;
	return ACTIVATION_STEP.Activation;
};

const samplePartnerSessionDataSource: PartnerSessionDataSource = {
	loadPartnerProfile: () =>
		SAMPLE_PARTNER_BY_DEMO[readPartnerDemo() ?? PARTNER_DEMO.Active],
};

export const partnerSessionDataSource = samplePartnerSessionDataSource;
